module.exports = __webpack_public_path__ + "img/logologin.89e24c5a.png";